/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodBundlesTableStatusEnum {
    CLOSED = 'CLOSED',
    OPEN = 'OPEN'
}
